import Phaser from 'phaser';
import { LOGICAL_WIDTH, LOGICAL_HEIGHT } from './render/layout';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { MainScene } from './scenes/MainScene';
import { InterstitialScene } from './scenes/InterstitialScene';
import { DogTrainingScene } from './scenes/DogTrainingScene';
import { OhNoScene } from './scenes/OhNoScene';
import { AnimDebugScene } from './scenes/AnimDebugScene';
import { WelcomeScene } from './scenes/WelcomeScene';

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game-root',
  backgroundColor: '#108aef',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: LOGICAL_WIDTH,
    height: LOGICAL_HEIGHT,
  },
  scene: [BootScene, PreloadScene, MainScene, InterstitialScene, DogTrainingScene, OhNoScene, AnimDebugScene, WelcomeScene],
  input: { mouse: { preventDefaultDown: true } },
});
// Dev-only window export, used by the headless-Chrome screenshot driver.
const env = (import.meta as unknown as { env?: { DEV?: boolean } }).env;
if (env?.DEV) {
  (window as unknown as { __game__: Phaser.Game }).__game__ = game;
}
